export const TAB_ID_MAP = {
  CLIENT_MTD_OVERVIEW: 1,
  CALLERS_BY_CLIENT: 2,
};

export const TABS = [
  { id: TAB_ID_MAP.CLIENT_MTD_OVERVIEW, title: 'Client MTD Overview' },
  { id: TAB_ID_MAP.CALLERS_BY_CLIENT, title: 'Callers by Client' },
];
